import { Controller } from '@hotwired/stimulus';

export default class PaymentFormController extends Controller {
  static targets = ['paymentElement'];
  static values = {
    confirmationUrl: String
  };

  initialize() {
    this.boundSubmitListener = this.handleFormSubmit.bind(this);
    this.boundResponseListener = this.handleFormResponse.bind(this);
  }

  connect() {
    this.element.addEventListener('turbo:submit-start', this.boundSubmitListener);
    this.element.addEventListener('turbo:submit-end', this.boundResponseListener);
  }

  disconnect() {
    this.element.removeEventListener('turbo:submit-start', this.boundSubmitListener);
    this.element.removeEventListener('turbo:submit-end', this.boundResponseListener);
  }

  paymentElementController() {
    return this.application.getControllerForElementAndIdentifier(this.paymentElementTarget, 'checkout--payment-element');
  }

  handleFormSubmit(event) {
    if (!this.paymentElementController().complete) {
      event.preventDefault();
    }

    this.dispatch('payment-start');
  }

  handleFormResponse(event) {
    if (!event.detail.success) {
      this.dispatch('payment-end');
      return;
    }

    event.preventDefault();

    this.processPayment();
  }

  async processPayment() {
    await this.paymentElementController().confirm(this.confirmationUrlValue);
    this.dispatch('payment-end');
  }
}
